import React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

function DeleteProductModal(props) {
  return (
    <>
      <Modal isOpen={props?.deleteModal} onClosed={props.toggleDeleteModalClose} toggle={props?.toggleDeleteModalClose}>
        <ModalHeader toggle={props?.toggleDeleteModalClose}>Delete Product </ModalHeader>

        <ModalBody>Are you sure want to delete this product ?</ModalBody>
        <ModalFooter>
          <Button color='primary' onClick={props?.handleConfirmDelete}>
            Delete
          </Button>{' '}
          <Button color='secondary' onClick={props?.toggleDeleteModalClose}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default DeleteProductModal;
